import Wizard from 'scoreboard/components/wizard'
import _ from 'lodash'
import FieldForm from 'scoreboard/datasets/edit/fields/field-form'
import LabelClustersForm from 'scoreboard/datasets/filters/label-clusters-form'

var FieldWizard = Wizard.extend({

	/** @type {Dataset} */
	model: null,

	/**
	 * @param options
	 * @param {DatasetField} options.field
	 */
	initialize: function(options) {
		this.options = _.extend(options, {
			field: _.clone(options.field)
		})
		this.field = this.options.field
		Wizard.prototype.initialize.call(this, _.defaults({}, options, {
			steps: 1
		}))
	},

	_viewConstructor: function(step) {
		if (step == 1) {
			return FieldForm
		} else if (this.field.fieldType === 'cluster') {
			return LabelClustersForm
		}
		// #38259 Do not throw an error here - it will just cause a hang
		console.error('Non cluster fields should require only one step')
	},

	_extendOptions: function(options) {
		Wizard.prototype._extendOptions.apply(this, arguments)
		_.extend(this.options, _.get(options, 'xhrResponse'))
	},

	/**
	 * @param {DatasetField} field
	 */
	finish: function(field) {
		this.trigger('done', field)
	}
})

export default FieldWizard
FieldWizard.__filename__ = 'datasets/edit/fields/field-wizard.js'
